import { render, staticRenderFns } from "./UploadSkyKids.vue?vue&type=template&id=85384f7a&lang=pug"
import script from "./UploadSkyKids.vue?vue&type=script&lang=js"
export * from "./UploadSkyKids.vue?vue&type=script&lang=js"
import style0 from "./UploadSkyKids.vue?vue&type=style&index=0&id=85384f7a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports